import styled, { css } from '../theme/styled';
import { CounterProps, StyledCounterProps } from './counter.types';

const sizeMap: Record<
  NonNullable<CounterProps['size']>,
  {
    size: number;
    paddingInline: number;
  }
> = {
  m: { size: 24, paddingInline: 8 },
  s: { size: 16, paddingInline: 4 },
};

const colorMap = (color: StyledCounterProps['$color']) => ({
  main: css`
    ${({ theme }) => css`
      background-color: ${theme.colors[color][500]};
      color: ${theme.colors.white};
    `}
  `,
  secondary: css`
    ${({ theme }) => css`
      background-color: ${theme.colors[color][100]};
      color: ${theme.colors[color][600]};
    `}
  `,
});

export const StyledCounter = styled.span<StyledCounterProps>`
  ${({ theme, $color, $size, $variant, $isDot }) => css`
    padding-inline: ${sizeMap[$size].paddingInline}px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: ${theme.radiuses.full};
    transition-property: background-color, color;
    transition-duration: ${theme.tokens.animation.duration.base};
    box-sizing: border-box;

    ${colorMap($color)[$variant]};

    ${$isDot
      ? css`
          padding: 0;
          width: 6px;
          height: 6px;
        `
      : css`
          min-width: ${sizeMap[$size].size}px;
          min-height: ${sizeMap[$size].size}px;
        `}
  `};
`;
